import * as coreClient from "@azure/core-client";

export const Order: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Order",
    modelProperties: {
      orderNumber: {
        serializedName: "orderNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      orderDate: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DDThh:mm:ss")
        },
        serializedName: "orderDate",
        required: true,
        type: {
          name: "String"
        }
      },
      orderstatus: {
        serializedName: "orderstatus",
        required: true,
        type: {
          name: "String"
        }
      },
      orderTotal: {
        serializedName: "orderTotal",
        type: {
          name: "Number"
        }
      },
      orderLines: {
        serializedName: "orderLines",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "OrderLine"
            }
          }
        }
      },
      customer: {
        serializedName: "customer",
        type: {
          name: "Composite",
          className: "Customer"
        }
      },
      discount: {
        serializedName: "discount",
        type: {
          name: "Composite",
          className: "OrderDiscount"
        }
      }
    }
  }
};

export const OrderLine: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OrderLine",
    modelProperties: {
      itemId: {
        serializedName: "itemId",
        required: true,
        type: {
          name: "Number"
        }
      },
      ticketTypeId: {
        serializedName: "ticketTypeId",
        required: true,
        type: {
          name: "String"
        }
      },
      quantity: {
        serializedName: "quantity",
        required: true,
        type: {
          name: "Number"
        }
      },
      itemPrice: {
        serializedName: "itemPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      price: {
        serializedName: "price",
        type: {
          name: "Number"
        }
      },
      subTotalPrice: {
        serializedName: "subTotalPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      paidPrice: {
        serializedName: "paidPrice",
        required: true,
        type: {
          name: "Number"
        }
      },
      applicants: {
        serializedName: "applicants",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Applicant"
            }
          }
        }
      }
    }
  }
};

export const Applicant: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Applicant",
    modelProperties: {
      itemId: {
        serializedName: "itemId",
        required: true,
        type: {
          name: "Number"
        }
      },
      quantityIndex: {
        serializedName: "quantityIndex",
        required: true,
        type: {
          name: "Number"
        }
      },
      fulfillmentMethod: {
        serializedName: "fulfillmentMethod",
        required: true,
        type: {
          name: "String"
        }
      },
      paymentMethodType: {
        serializedName: "paymentMethodType",
        required: true,
        type: {
          name: "String"
        }
      },
      customer: {
        serializedName: "customer",
        type: {
          name: "Composite",
          className: "Customer"
        }
      },
      startDate: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DD")
        },
        serializedName: "startDate",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Customer: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Customer",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DD")
        },
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      },
      mobileNumber: {
        serializedName: "mobileNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      address: {
        serializedName: "address",
        type: {
          name: "Composite",
          className: "Address"
        }
      }
    }
  }
};

export const Address: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Address",
    modelProperties: {
      address1: {
        serializedName: "address1",
        required: true,
        type: {
          name: "String"
        }
      },
      address2: {
        serializedName: "address2",
        nullable: true,
        type: {
          name: "String"
        }
      },
      town: {
        serializedName: "town",
        required: true,
        type: {
          name: "String"
        }
      },
      postCode: {
        serializedName: "postCode",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const OrderDiscount: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OrderDiscount",
    modelProperties: {
      totalDiscountValue: {
        serializedName: "totalDiscountValue",
        required: true,
        type: {
          name: "Number"
        }
      },
      discountLabel: {
        serializedName: "discountLabel",
        required: true,
        type: {
          name: "String"
        }
      },
      discountItems: {
        serializedName: "discountItems",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "OrderLineDiscount"
            }
          }
        }
      }
    }
  }
};

export const OrderLineDiscount: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OrderLineDiscount",
    modelProperties: {
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      },
      discountValue: {
        serializedName: "discountValue",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const ApiError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      shortDescription: {
        serializedName: "shortDescription",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};
